var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkout-header-map"},[(!_vm.isMapReady)?_c('div',{staticClass:"loader-container"},[_c('cmg-inline-loader',{staticClass:"loader"})],1):_vm._e(),_c('div',{staticClass:"map-container"},[_c('div',{ref:"map",staticClass:"map",class:{ 'hidden': !_vm.isMapReady }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }